import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
    equipmentServices: {count: 0, rows: []},
    selectedEquipmentMassServices: [],
    loading: false,
    selectedEquipmentMassServicesLoading: false,
    checkDelete: {},
};

const requestEquipmentServicesStart = ( state, action ) => {
    return updateObject( state, { loading: true } );
};

const requestSelectedEquipmentMassServicesStart = ( state, action ) => {
    return updateObject( state, { selectedEquipmentMassServicesLoading: true } );
};

const fetchEquipmentServicesSuccess = ( state, action ) => {
    return updateObject( state, {
        equipmentServices: action.equipmentServices,
        loading: false
    });
};

const fetchSelectedEquipmentMassServicesSuccess = ( state, action ) => {
    return updateObject( state, {
        selectedEquipmentMassServices: action.selectedEquipmentMassServices,
        selectedEquipmentMassServicesLoading: false
    });
};

const requestEquipmentServicesFail = ( state, action ) => {
    return updateObject( state, { loading: false } );
};

const requestSelectedEquipmentMassServicesFail = ( state, action ) => {
    return updateObject( state, { selectedEquipmentMassServicesLoading: false } );
};

const deleteEquipmentServicesSuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const checkDeleteEquipmentServicesSuccess = (state, action) => {
  return updateObject(state, { 
    checkDelete: action.checkDelete,
    loading: false 
  });
}

const hardDeleteEquipmentServicesSuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const updateEquipmentServicesSuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const postEquipmentServicesSuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const postMassServiceSuccess = (state, action) => {
    return updateObject( state, { selectedEquipmentServicesLoading: false } );
}

const requestMassServicesFail = (state, action) => {
    return updateObject( state, { selectedEquipmentServicesLoading: false } );
}

const inactivateActivateEquipmentServiceStart = (state) => {
    return updateObject( state, { loading: true } );
}

const inactivateActivateEquipmentServiceSuccessFail = (state) => {
    return updateObject( state, { loading: false } );
}
const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.REQUEST_EQUIPMENT_SERVICES_START: return requestEquipmentServicesStart( state, action );
        case actionTypes.REQUEST_SELECTED_EQUIPMENT_MASS_SERVICES_START: return requestSelectedEquipmentMassServicesStart( state, action );
        case actionTypes.FETCH_EQUIPMENT_SERVICES_SUCCESS: return fetchEquipmentServicesSuccess( state, action );
        case actionTypes.FETCH_SELECTED_EQUIPMENT_MASS_SERVICES_SUCCESS: return fetchSelectedEquipmentMassServicesSuccess( state, action );
        case actionTypes.REQUEST_EQUIPMENT_SERVICES_FAIL: return requestEquipmentServicesFail( state, action );
        case actionTypes.REQUEST_SELECTED_EQUIPMENT_MASS_SERVICES_FAIL: return requestSelectedEquipmentMassServicesFail( state, action );
        case actionTypes.DELETE_EQUIPMENT_SERVICES_SUCCESS: return deleteEquipmentServicesSuccess( state, action );
        case actionTypes.CHECK_DELETE_EQUIPMENT_SERVICES_SUCCESS: return checkDeleteEquipmentServicesSuccess(state, action);
        case actionTypes.UPDATE_EQUIPMENT_SERVICES_SUCCESS: return updateEquipmentServicesSuccess( state, action );
        case actionTypes.POST_EQUIPMENT_SERVICES_SUCCESS: return postEquipmentServicesSuccess( state, action );
        case actionTypes.HARD_DELETE_EQUIPMENT_SERVICES_SUCCESS: return hardDeleteEquipmentServicesSuccess( state, action );
        case actionTypes.POST_MASS_SERVICE_SUCCESS: return postMassServiceSuccess( state, action );
        case actionTypes.REQUEST_MASS_SERVICES_FAIL: return requestMassServicesFail( state, action );

        case actionTypes.EQUIPMENT_SERVICES_INACTIVATE_START: return inactivateActivateEquipmentServiceStart(state);
        case actionTypes.EQUIPMENT_SERVICES_INACTIVATE_SUCCESS: return inactivateActivateEquipmentServiceSuccessFail(state);
        case actionTypes.EQUIPMENT_SERVICES_INACTIVATE_FAIL: return inactivateActivateEquipmentServiceSuccessFail(state);
        case actionTypes.EQUIPMENT_SERVICES_ACTIVATE_START: return inactivateActivateEquipmentServiceStart(state);
        case actionTypes.EQUIPMENT_SERVICES_ACTIVATE_SUCCESS: return inactivateActivateEquipmentServiceSuccessFail(state);
        case actionTypes.EQUIPMENT_SERVICES_ACTIVATE_FAIL: return inactivateActivateEquipmentServiceSuccessFail(state);

        default: return state;
    }
};

export default reducer;